import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { ArrowLeftRight } from 'lucide-react';

interface BridgePageProps { user: any; }

export function BridgePage({ user }: BridgePageProps) {
  const [amount, setAmount] = useState('');

  // [2026-09-11] 브릿지는 아직 오픈 전이다. 입금받을 트레저리 주소를 화면에 노출하면
  // 사용자가 실제로 이더리움에서 HANDY를 보내버릴 수 있어(되돌릴 수 없는 사고) 주소
  // 표시·복사 기능과 트랜잭션 해시 입력을 전부 제거했다. 화면은 "어떤 기능인지"만
  // 보여주는 미리보기 상태로 두고, 실행 버튼은 '오픈 예정'으로 비활성화한다.
  const handleBridge = () => {
    toast.info('브릿지는 오픈 예정입니다.');
  };

  return (
    <div className="p-4 space-y-4">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold" style={{color:'#FF6B00'}}>Handy Bridge</h2>
        <p className="text-muted-foreground text-sm">이더리움 HANDY(ERC-20) ↔ Handy 체인 wHANDY</p>
      </div>
      <Card className="border-orange-200">
        <CardContent className="p-6 space-y-5">
          <div className="rounded-xl py-3 px-4 text-center text-sm font-bold text-white"
               style={{background:'#FF6B00'}}>
            HANDY (ERC-20) → wHANDY
          </div>
          <div className="rounded-xl p-4 bg-muted space-y-2">
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>From</span>
              <span>Ethereum (ERC-20 HANDY)</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-9 h-9 rounded-full bg-white border border-orange-200 flex items-center justify-center overflow-hidden shrink-0">
                <img src="/handy-logo.svg" alt="HANDY" className="w-6 h-6" />
              </div>
              <div className="flex-1"><p className="font-bold">HANDY (ERC-20)</p></div>
              <Input value={amount} onChange={e=>setAmount(e.target.value)}
                type="number" placeholder="0.00"
                className="w-32 text-right border-0 bg-transparent text-lg font-medium"/>
            </div>
          </div>

          <div className="flex justify-center">
            <div className="w-10 h-10 rounded-full border-2 flex items-center justify-center opacity-40"
              style={{borderColor:'#FF6B00'}}>
              <ArrowLeftRight className="w-5 h-5" style={{color:'#FF6B00'}}/>
            </div>
          </div>
          <div className="rounded-xl p-4 bg-orange-50 space-y-2">
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>To</span>
              <span>Handy 체인 (wHANDY)</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{background:'#FF6B00'}}>
                <img src="/handy-logo.svg" alt="wHANDY" className="w-6 h-6 brightness-0 invert" />
              </div>
              <div className="flex-1"><p className="font-bold">wHANDY</p></div>
              <div className="text-right">
                <p className="text-lg font-medium">{amount?parseFloat(amount).toFixed(2):'0.00'}</p>
                <p className="text-xs text-muted-foreground">1:1</p>
              </div>
            </div>
          </div>
          <p className="text-[11px] text-muted-foreground text-center">HANDY(ERC-20) ↔ wHANDY 1:1 교환 · 수수료는 가스비만 부과됩니다</p>
          <Button onClick={handleBridge}
            className="w-full h-12 font-bold cursor-not-allowed"
            style={{background:'#E5E7EB', color:'#6B7280'}}>
            오픈 예정
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
